import React, { useEffect } from "react";

interface PageMetaProps {
  title?: string;
  description?: string;
  favicon?: string;
  metaTags?: Array<{ name: string; content: string }>;
}

const PageMeta: React.FC<PageMetaProps> = ({ title, description, favicon, metaTags }) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let descTag = document.querySelector('meta[name="description"]');
      if (!descTag) {
        descTag = document.createElement('meta');
        descTag.setAttribute('name', 'description');
        document.head.appendChild(descTag);
      }
      descTag.setAttribute('content', description);
    }

    if (favicon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = favicon;
    }
    
    if (metaTags) {
      metaTags.forEach(({ name, content }) => {
        let tag = document.querySelector(`meta[name='${name}']`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('name', name);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      });
    }
  }, [title, description, favicon, metaTags]);

  return null;
};

export default PageMeta;
